import CanvasDesktopView from './desktop/Canvas.desktop.view';
import CanvasMobileView from './mobile/Canvas.mobile.view';
import type CanvasProperties from './Canvas.properties.ts';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import { useIsMobileDevice } from '../../tools/hooks/useIsMobileDevice.ts';

export default function CanvasView(props: CanvasProperties) {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <CanvasMobileView {...props} />}
      {isDesktop && <CanvasDesktopView {...props} />}
    </>
  );
}
